import { storageToSupabase } from "../supabase/functions/save-order";
import { countrySelector } from "./countrySelector";
import { errorMessage } from "./errorMessage";


countrySelector();

// Función para guardar los datos en sessionStorage
function saveData() {
    const name = document.getElementById('name').value;
    const title = document.querySelector('input[name="title"]:checked')?.value;
    const surname = document.getElementById('surName').value;
    const phone = document.getElementById('phone').value;
    const email = document.getElementById('email').value;
    const repeatEmail = document.getElementById('repeatEmail').value;
    const children = document.getElementById('children').checked;
    const otherNeeds = document.getElementById('otherNeeds').value;
    const consent = document.getElementById('consent').checked;
    let selectedCountry = document.querySelector('.select-selected').textContent.replace('Country: ', '');

    // Convertir selectedCountry a texto plano
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = selectedCountry;
    selectedCountry = tempDiv.textContent || tempDiv.innerText || '';

    //Comprobar que no queden valores clave por rellenar
    if (!name) return errorMessage ('Please provide a name');
    if (!selectedCountry) return errorMessage ('Please select your country');
    if (!phone) return errorMessage ('Please provide a phone nunmber');
    if (!email) return errorMessage('Please provide your mail');
    if (email !== repeatEmail) return errorMessage('Email and Repeat email do not match');
    if (consent != true) return errorMessage('Please accept the data processing consent to proceed.')

    //Guardar los valores
    sessionStorage.setItem('name', name);
    sessionStorage.setItem('title', title);
    sessionStorage.setItem('surname', surname);
    sessionStorage.setItem('phone', phone);
    sessionStorage.setItem('email', email);
    sessionStorage.setItem('children', children);
    sessionStorage.setItem('otherNeeds', otherNeeds);
    sessionStorage.setItem('consent', consent);
    sessionStorage.setItem('country', selectedCountry); 

    return true;
}   

// Agregar evento al botón Next
document.getElementById('submitButton').addEventListener('click', async function(event) {
    event.preventDefault(); 
    if (saveData() === true) {
        await storageToSupabase();
        window.location.href = 'thanks.html';    
    }
});